// Brand polish for the Wishlist Engine app's injected UI. The styling side
// lives in pbr-theme.css ("Wishlist Engine app UI overrides") — this module
// adds the DOM pieces CSS can't:
//
// - Guest "please login" toast: the app auto-dismisses it after ~3s, which
//   isn't enough time to act on it. Hide the app's toast (leaving its node
//   in place so the app's cleanup timers still find it) and show our own
//   persistent branded dialog with a real "Log in" CTA instead.
// - Wishlist modal: the app's header bar ships an empty left slot; fill it
//   with the wordmark so the popup reads as ours.
// - Login links: the app hardcodes /account, which breaks from preview
//   hosts; theme.liquid exposes the store's real customer-authentication
//   URL as window.pbrAccountLoginUrl and every login link gets it.
//
// Success toasts ("added to your wishlist") keep the app's behavior — the
// pbr-theme.css overrides center and restyle them, and auto-dismiss is fine
// for a confirmation.

const loginUrl = () => window.pbrAccountLoginUrl || '/account/login';

function showLoginDialog(appMessage) {
  if (document.querySelector('.pbr-wishlist-login')) return;

  const backdrop = document.createElement('div');
  backdrop.className = 'pbr-wishlist-login__backdrop';

  const dialog = document.createElement('div');
  dialog.className = 'pbr-wishlist-login';
  dialog.setAttribute('role', 'dialog');
  dialog.setAttribute('aria-label', 'Log in to use your wishlist');

  const dismiss = () => {
    backdrop.remove();
    dialog.remove();
    document.removeEventListener('keydown', onKeydown);
  };
  const onKeydown = (event) => {
    if (event.key === 'Escape') dismiss();
  };
  backdrop.addEventListener('click', dismiss);
  document.addEventListener('keydown', onKeydown);

  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'pbr-wishlist-login__close';
  close.setAttribute('aria-label', 'Close');
  close.textContent = '✕';
  close.addEventListener('click', dismiss);

  const brand = document.createElement('span');
  brand.className = 'pbr-wishlist-login__brand';
  brand.textContent = 'Palm Beach Regency';

  // Clone the app's own message node — keeps its (localized) wording and
  // the inline login link without handling HTML strings.
  const message = appMessage.cloneNode(true);
  message.querySelectorAll('a').forEach((a) => (a.href = loginUrl()));

  const cta = document.createElement('a');
  cta.className = 'pbr-btn pbr-btn--dark pbr-wishlist-toast__cta';
  cta.href = loginUrl();
  cta.textContent = 'Log in';

  dialog.append(close, brand, message, cta);
  document.body.append(backdrop, dialog);
  close.focus();
}

function handleToast(popup) {
  // Only the guest "please login" toast carries an account link.
  const inlineLink = popup.querySelector('.wishlist-p-right a[href*="account"]');
  const appMessage = popup.querySelector('.wishlist-p-right h3');
  if (!inlineLink || !appMessage) return;
  popup.style.display = 'none';
  showLoginDialog(appMessage);
}

function enhanceModal(popup) {
  const login = popup.querySelector('.sewp-header a');
  if (login) login.href = loginUrl();
  const slot = popup.querySelector('.sewp-header > div:first-child');
  if (!slot || slot.querySelector('.pbr-wishlist-modal__brand')) return;
  const brand = document.createElement('span');
  brand.className = 'pbr-wishlist-modal__brand';
  brand.textContent = 'Palm Beach Regency';
  slot.appendChild(brand);
}

function enhance(node) {
  if (!(node instanceof HTMLElement)) return;
  if (node.classList.contains('pbr-wishlist-login')) return;
  if (node.classList.contains('wishlist-popup')) handleToast(node);
  if (node.classList.contains('sewp-engine-popup')) enhanceModal(node);
}

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    mutation.addedNodes.forEach(enhance);
  }
});
observer.observe(document.documentElement, { childList: true, subtree: true });

// In case the app rendered before this script ran.
document.querySelectorAll('.wishlist-popup, .sewp-engine-popup').forEach(enhance);
